; (function (jQuery) {

	"use strict";

	function CWCookieBanner()
	{
		var global = {
			analyticsScriptsLoaded: false,
			functionalScriptsLoaded: false,
			embeddedContentLoaded: false
		};

		var settings = {
			gtmCode: 'UA-50479915-1'
		};

		var fn = {
			init: function()
			{
				if (window.BMCookieConsent && typeof window.BMCookieConsent.preferenceGiven === 'function' && window.BMCookieConsent.preferenceGiven()) {
					var consent = window.BMCookieConsent.getPreferences();
					fn.onConsentGiven(consent);
				} else {
					document.addEventListener('bmcc-consent-selected', function (e) {
						fn.onConsentGiven(e.detail);
					});
				}
			},

			onConsentGiven: function(consent)
			{
				if (consent.analytics && !global.analyticsScriptsLoaded)
				{
					fn.loadGoogleAnalytics();
					global.analyticsScriptsLoaded = true;
				}

				if (consent.necessary && !global.functionalScriptsLoaded)
				{
					global.functionalScriptsLoaded = true;
				}

				if (consent.embeds && !global.embeddedContentLoaded)
				{
					window.BMCookieConsent.loadEmbeddedContent();
					global.embeddedContentLoaded = true;
				}
			},

			loadGoogleAnalytics: function()
			{
				window.dataLayer = window.dataLayer || [];
				function gtag(){dataLayer.push(arguments);}
				gtag('js', new Date());

				gtag('config', settings.gtmCode, { 'anonymize_ip': true });

				window.BMCookieConsent.loadScript('https://www.googletagmanager.com/gtag/js?id=' + settings.gtmCode);
			}
		}

		jQuery(fn.init);
	}

	new CWCookieBanner();
})(jQuery);